<template>
  <section v-if="isEndowmentMode" class="endowment-login-section">
    <div class="endowment-login-container">
      <div class="endowment-login-card p-card p-component shadow-sm rounded-4">
        <div class="card-content">
          <div class="login-header">
            <h3>كن صديقاً لشفاء</h3>
            <p>أهلاً بك من جديد لدينا سجل الدخول للإطلاع على تفاصيل حسابك</p>
          </div>
          
          <form class="endowment-form" @submit.prevent>
            <div v-if="state.donorApiError.length" class="error-messages">
              <p v-for="(error, index) in state.donorApiError" class="api-error-container" :key="index">
                {{ error }}
              </p>
            </div>
            
            <div class="input-row" v-if="!state.emailOtpMode">
              <div class="input-wrapper">
                <InputText
                  id="endowment-donor-phone"
                  v-model="state.donorPhone"
                  class="phone-input"
                  :class="{ 'p-invalid': state.donorPhoneError }"
                  maxlength="10"
                  placeholder=" "
                  :disabled="state.isSendingOtp || state.timerCount > 0"
                  @input="handleDonorPhoneInput"
                />
                <label for="endowment-donor-phone" class="input-label">رقم الجوال</label>
                <Button
                  :label="verificationButtonLabel"
                  class="verify-btn"
                  @click="sendVerificationCode"
                  :disabled="
                    state.donorPhone.length !== 10 ||
                    state.isSendingOtp ||
                    state.isSendingEmailOtp ||
                    state.timerCount > 0
                  "
                  :loading="state.isSendingOtp"
                />
              </div>
              <small v-if="state.donorPhoneError" class="p-error">{{ state.donorPhoneError }}</small>
            </div>
            
            <div v-if="state.emailOtpMode" class="email-otp-heading text-center py-3">
              <h5>أدخل رمز التحقق المرسل للبريد الإلكتروني للمتابعة</h5>
            </div>
            
            <div class="input-row" v-if="state.verificationSent">
              <div class="input-wrapper">
                <InputText
                  type="text"
                  id="endowment-donor-otp"
                  v-model="state.donorOtp"
                  class="otp-input"
                  :class="{ 'p-invalid': state.otpError }"
                  maxlength="6"
                  placeholder=" "
                  autocomplete="one-time-code"
                  @input="handleOtpInput"
                />
                <label for="endowment-donor-otp" class="input-label">رمز التحقق</label>
                <Button
                  v-if="state.emailOtpMode"
                  :label="emailVerificationButtonLabel"
                  class="verify-btn"
                  @click="sendEmailOtp"
                  :disabled="state.isSendingEmailOtp || state.isSendingOtp || state.timerCount > 0"
                  :loading="state.isSendingEmailOtp"
                />
              </div>
              <small v-if="state.otpError" class="p-error">{{ state.otpError }}</small>
            </div>
            
            <div v-if="state.verificationSent && state.donorEmail && !state.emailOtpMode && (state.timerCount === 0 || state.emailLinkShown)" class="text-center mt-3">
              <a 
                href="#" 
                @click.prevent="sendEmailOtp" 
                class="email-otp-link"
              >
                إرسال الرمز عن طريق البريد الإلكتروني
              </a>
            </div>
            
            <div
              class="terms-row"
              v-if="state.verificationSent && state.isNewUser"
            >
              <Checkbox
                v-model="state.termsAccepted"
                :binary="true"
                inputId="endowment-terms"
              />
              <label for="endowment-terms" class="terms-label">
                <span>أوافق على</span>
                <router-link
                  to="/privacy-policy"
                  target="_blank"
                >الشروط والأحكام</router-link>
              </label>
            </div>
            
            <Button
              v-if="state.verificationSent"
              label="تسجيل الدخول"
              class="login-btn"
              @click="handleEndowmentDonorLogin"
              :disabled="
                (!state.emailOtpMode && state.donorPhone.length !== 10) ||
                state.donorOtp.length !== 6 ||
                (state.isNewUser && !state.termsAccepted) ||
                state.isLoggingIn ||
                (!state.emailOtpMode && !isOtpValidForCurrentPhone)
              "
              :loading="state.isLoggingIn"
            />
            
            <Button
              v-if="state.verificationSent && state.emailOtpMode"
              label="إغلاق"
              class="back-btn"
              @click="backToSmsMode"
            />
          </form>
        </div>
      </div>
    </div>
  </section>

  <section v-else class="container pb-2">
    <TabView class="loginform" @tab-change="onTabChange">
      <TabPanel header="متبرع">
        <div class="py-4 px-sm-4 p-md-5">
          <div class="login-header">
            <h3>كن صديقاً لشفاء</h3>
            <p>أهلاً بك من جديد لدينا سجل الدخول للإطلاع على تفاصيل حسابك</p>
          </div>
          <form class="d-flex flex-column gap-4" @submit.prevent>
            <div
              v-if="state.donorApiError.length"
            >
              <p v-for="(error, index) in state.donorApiError" class="api-error-container" :key="index">
                {{ error }}
              </p>
            </div>
            <div class="w-100 d-flex flex-column">
              <div v-if="state.emailOtpMode" class="email-otp-heading text-center py-3">
                <h5 style="color: #333; font-weight: 600;">أدخل رمز التحقق المرسل للبريد الإلكتروني للمتابعة</h5>
              </div>

              <span v-else class="p-float-label p-input-icon-left w-100">
                <Button
                  :label="verificationButtonLabel"
                  class="btn-verify p-button-text"
                  @click="sendVerificationCode"
                  :disabled="
                    state.donorPhone.length !== 10 ||
                    state.isSendingOtp ||
                    state.isSendingEmailOtp ||
                    state.timerCount > 0
                  "
                  :loading="state.isSendingOtp"
                />
                <InputText
                  id="donor-phone"
                  v-model="state.donorPhone"
                  class="w-100"
                  :class="{ 'p-invalid': state.donorPhoneError }"
                  maxlength="10"
                  :disabled="state.isSendingOtp || state.timerCount > 0"
                  @input="handleDonorPhoneInput"
                />
                <label for="donor-phone" class="end-0 pe-3">رقم الجوال</label>
              </span>
              <small v-if="state.donorPhoneError" class="p-error px-2">{{
                state.donorPhoneError
              }}</small>
            </div>

            <span class="p-float-label p-input-icon-left w-100" v-if="state.verificationSent">
              <Button
                v-if="state.emailOtpMode"
                :label="emailVerificationButtonLabel"
                class="btn-verify p-button-text"
                @click="sendEmailOtp"
                :disabled="state.isSendingEmailOtp || state.isSendingOtp || state.timerCount > 0"
                :loading="state.isSendingEmailOtp"
              />
              <InputText
                type="text"
                id="donor-password"
                v-model="state.donorOtp"
                maxlength="6"
                class="w-100"
                :class="{ 'p-invalid': state.otpError }"
                autocomplete="one-time-code"
                @input="handleOtpInput"
              />
              <label for="donor-password" class="end-0 pe-3">رمز التحقق</label>
              <small v-if="state.otpError" class="p-error px-2">{{ state.otpError }}</small>
            </span>

            <div v-if="state.verificationSent && state.donorEmail && !state.emailOtpMode && (state.timerCount === 0 || state.emailLinkShown)" class="text-center mt-2">
              <a 
                href="#" 
                @click.prevent="sendEmailOtp" 
                class="email-otp-link"
                style="color: #5581c4; text-decoration: none; font-size: 0.95rem;"
              >
                إرسال الرمز عن طريق البريد الإلكتروني
              </a>
            </div>

            <div
              class="extra-links d-flex align-items-center gap-2 mt-2"
              v-if="state.verificationSent && state.isNewUser"
            >
              <Checkbox
                v-model="state.termsAccepted"
                :binary="true"
                inputId="terms"
              />
              <label for="terms" class="d-flex gap-1">
                <span>أوافق على</span>
                <router-link
                  to="/privacy-policy"
                  target="_blank"
                  style="text-decoration: underline"
                  >الشروط والأحكام</router-link
                >
              </label>
            </div>
            <Button
              v-if="state.verificationSent"
              label="تسجيل الدخول"
              class="w-100 p-3 mt-4"
              @click="handleDonorLogin"
              :disabled="
                (!state.emailOtpMode && state.donorPhone.length !== 10) ||
                state.donorOtp.length !== 6 ||
                (state.isNewUser && !state.termsAccepted) ||
                state.isLoggingIn ||
                (!state.emailOtpMode && !isOtpValidForCurrentPhone)
              "
              :loading="state.isLoggingIn"
            />

            <Button
              v-if="state.verificationSent && state.emailOtpMode"
              label="إغلاق"
              class="w-100 p-3 p-button-secondary"
              @click="backToSmsMode"
            />
          </form>
        </div>
      </TabPanel>
      <TabPanel header="جمعية">
        <div class="py-4 px-sm-4 p-md-5">
          <div class="login-header">
            <h3>كن صديقاً لشفاء</h3>
            <p>أهلاً بك من جديد لدينا سجل الدخول للإطلاع على تفاصيل حسابك</p>
          </div>
          <form class="d-flex flex-column gap-4" @submit.prevent>
            <div
              v-if="state.charityApiError.length"
            >
              <p v-for="(error, index) in state.charityApiError" class="api-error-container" :key="index">
                {{ error }}
              </p>
            </div>
            <div class="w-100 d-flex flex-column">
              <span class="p-float-label w-100">
                <InputText
                  id="charity-phone"
                  v-model="state.charityPhone"
                  class="w-100"
                  :class="{ 'p-invalid': state.charityPhoneError }"
                  maxlength="10"
                  @input="handleCharityPhoneInput"
                />
                <label for="charity-phone" class="end-0 pe-3">رقم الجوال</label>
              </span>
              <small v-if="state.charityPhoneError" class="p-error px-2">{{
                state.charityPhoneError
              }}</small>
            </div>

            <span class="p-float-label p-input-icon-left w-100">
              <i
                :class="[
                  'btn-toggle-mask pi',
                  state.charityPasswordVisible ? 'pi-eye-slash' : 'pi-eye',
                ]"
                @click="
                  state.charityPasswordVisible = !state.charityPasswordVisible
                "
              />
              <InputText
                :type="state.charityPasswordVisible ? 'text' : 'password'"
                id="charity-password"
                v-model="state.charityPassword"
                maxlength="255"
                class="w-100"
              />
              <label for="charity-password" class="end-0 pe-3"
                >كلمة المرور</label
              >
            </span>

            <Button
              label="تسجيل الدخول"
              class="w-100 p-3 mt-4"
              @click="handleCharityLogin"
              :disabled="
                state.charityPhone.length !== 10 ||
                !state.charityPassword ||
                state.isCharityLoggingIn
              "
              :loading="state.isCharityLoggingIn"
            />

            <div
              class="extra-links d-flex justify-content-center align-items-center gap-3 mt-3"
            >
              <router-link to="/forget-password?type=charity"
                >نسيت كلمة المرور ؟</router-link
              >
              <span class="fw-bold">·</span>
              <button type="button" class="link-btn" @click="onAddNewCharity">إضافة جمعية جديدة</button>
            </div>
          </form>
          <AlertBox
            :showModal="state.addCharityDisabledPopup"
            title="طلبات تسجيل الجمعيات موقوفة هذه الفترة"
            actionLabel="العودة إلى الصفحة الرئيسية"
            @close="state.addCharityDisabledPopup=false"
            @action="router.push('/home')"/>
        </div>
      </TabPanel>
    </TabView>
  </section>
</template>

<script setup>
import { reactive, computed, onMounted, onUnmounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { STORE_ENUM } from "@/store/store.enums";
import { saudiPhoneValidator } from "@/helpers/helpers";
import { setLocalValue } from "@/hooks/useLocalStorage";
import AuthService from "@/services/auth.service";
import JwtUtilService from "@/services/jwt.util.service";
import OTPService, { OTP_TYPE } from "@/services/otp.service";
import AlertBox from "@/components/layout/AlertBox.vue";
const store = useStore();
const router = useRouter();
const route = useRoute();

const state = reactive({
  donorPhone: "",
  donorOtp: "",
  charityPhone: "",
  charityPassword: "",
  donorEmail: "",
  donorPhoneError: "",
  charityPhoneError: "",
  otpError: "",
  donorApiError: [],
  charityApiError: [],
  verificationSent: false,
  charityPasswordVisible: false,
  timerCount: 0,
  isSendingOtp: false,
  isSendingEmailOtp: false,
  isLoggingIn: false,
  isCharityLoggingIn: false,
  isNewUser: false,
  termsAccepted: false,
  lastSentDonorPhone: "",
  newDonor: false,
  activeTabIndex: 0,
  isCharityAPICalled: false,
  addNewCharityFlag: true,
  webOtpSupported: false,
  addCharityDisabledPopup: false,
  showEmailOtpOption: false,
  emailOtpMode: false,
  emailOtpSent: false,
  emailLinkShown: false,
});

let timerInterval = null;
let otpAbortController = null;
let currentOtpRequest = null;
let currentLoginRequest = null;

const verificationButtonLabel = computed(() => {
  if (state.timerCount > 0) {
    const minutes = String(Math.floor(state.timerCount / 60)).padStart(2, "0");
    const seconds = String(state.timerCount % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  }
  if (state.verificationSent && state.donorPhone === state.lastSentDonorPhone) {
    return "إعادة إرسال";
  }
  return "تحقق";
});

const emailVerificationButtonLabel = computed(() => {
  if (state.timerCount > 0) {
    const minutes = String(Math.floor(state.timerCount / 60)).padStart(2, "0");
    const seconds = String(state.timerCount % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  }
  if (state.emailOtpSent) {
    return "إعادة إرسال";
  }
  return "تحقق";
});

const isOtpValidForCurrentPhone = computed(() => {
  return state.donorPhone === state.lastSentDonorPhone && state.verificationSent;
});

const isEndowmentMode = computed(() => {
  return route.query.mode === 'endowments';
});

const clearTimer = () => {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
};

const stopOtpDetection = () => {
  if (otpAbortController) {
    try {
      otpAbortController.abort();
    } catch (error) {
      console.warn("Error aborting OTP detection:", error);
    } finally {
      otpAbortController = null;
    }
  }
};

const resetDonorState = () => {
  stopOtpDetection();
  clearTimer();
  state.verificationSent = false;
  state.timerCount = 0;
  state.donorOtp = "";
  state.otpError = "";
  state.isNewUser = false;
  state.termsAccepted = false;
  state.lastSentDonorPhone = "";
  state.donorApiError = [];
  state.showEmailOtpOption = false;
  state.emailOtpMode = false;
  state.emailOtpSent = false;
  state.emailLinkShown = false;
};

const resetCharityState = () => {
  state.charityApiError = [];
  state.charityPhoneError = "";
};

const startOtpDetection = async () => {
  stopOtpDetection();
  
  if (!state.webOtpSupported || !state.verificationSent) {
    return;
  }

  try {
    await nextTick();
    
    otpAbortController = new AbortController();
    
    const otp = await navigator.credentials.get({
      otp: { transport: ["sms"] },
      signal: otpAbortController.signal,
    });
    
    if (otp && otp.code && state.verificationSent && isOtpValidForCurrentPhone.value) {
      state.donorOtp = otp.code;
      state.otpError = "";
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      return;
    }
    if (error.name === 'NotSupportedError') {
      console.warn("WebOTP not supported on this device");
      state.webOtpSupported = false;
    } else if (error.name === 'SecurityError') {
      console.warn("WebOTP blocked by security policy");
    } else {
      console.warn("OTP auto-detection failed:", error.message);
    }
  }
};

const startTimer = () => {
  clearTimer();

  state.timerCount = 60;
  timerInterval = setInterval(() => {
    state.timerCount--;
    if (state.timerCount <= 0) {
      clearInterval(timerInterval);
      timerInterval = null;
      if (state.donorEmail && !state.emailOtpMode) {
        state.emailLinkShown = true;
      }
    }
  }, 1000);
};

const fetchCharityLoginFlag = async () => {
  try {
    const { data: { result } } = await AuthService.getCharityLoginFlag();
    state.addNewCharityFlag = result.add_a_new_association;
    state.isCharityAPICalled = true;
  } catch (error) {
    console.error("Failed to get charity login flag:", error);
  }
};

const onTabChange = async (event) => {
  if (event.index === 1 && !state.isCharityAPICalled) {
    await fetchCharityLoginFlag();
  }
};

const onAddNewCharity = async () => {
  if (!state.isCharityAPICalled) await fetchCharityLoginFlag();
  if (state.addNewCharityFlag) router.push("/create-account/1");
  else openAlert();
};

const handleDonorPhoneInput = () => {
  state.donorPhoneError = "";
  state.donorApiError = [];
  
  if (state.verificationSent && state.donorPhone !== state.lastSentDonorPhone) {
    stopOtpDetection();
    state.donorOtp = "";
    state.otpError = "يرجى طلب رمز تحقق جديد لهذا الرقم";
  }
};

const handleCharityPhoneInput = () => {
  state.charityPhoneError = "";
  state.charityApiError = [];
};

const handleOtpInput = () => {
  state.otpError = "";
  state.donorApiError = [];
  
  if (state.donorOtp.length > 0 && !/^\d+$/.test(state.donorOtp)) {
    state.otpError = "رمز التحقق يجب أن يحتوي على أرقام فقط";
  }
};

const sendVerificationCode = async () => {
  if (currentOtpRequest || state.isSendingOtp) {
    return;
  }

  state.donorPhoneError = "";
  state.donorApiError = [];
  state.otpError = "";

  if (!saudiPhoneValidator(state.donorPhone)) {
    state.donorPhoneError = "الرجاء إدخال رقم جوال سعودي صحيح.";
    return;
  }

  if (state.timerCount > 0) {
    return;
  }

  state.isSendingOtp = true;

  if (state.donorPhone !== state.lastSentDonorPhone) {
    state.termsAccepted = false;
  }

  try {
    currentOtpRequest = AuthService.createAndSendOtp(state.donorPhone);
    const { data } = await currentOtpRequest;

    state.isNewUser = data?.result?.user_created || false;
    state.verificationSent = true;
    state.lastSentDonorPhone = state.donorPhone;
    state.newDonor = data?.result?.user_created;
    state.donorEmail = data?.result?.show_email_link;
    state.donorOtp = "";

    startTimer();

    startOtpDetection();
    
  } catch (error) {
    console.error("OTP send error:", error);
    
    if (error.response?.data?.errors) {
      state.donorApiError = error.response.data.errors;
    } else {
      state.donorApiError = ["حدث خطأ أثناء إرسال رمز التحقق. يرجى المحاولة مرة أخرى."];
    }
    
    if (!state.verificationSent) {
      resetDonorState();
    }
  } finally {
    state.isSendingOtp = false;
    currentOtpRequest = null;
  }
};

const sendEmailOtp = async () => {
  if (state.isSendingEmailOtp) {
    return;
  }

  state.donorApiError = [];
  state.otpError = "";

  if (!state.donorEmail) {
    state.donorApiError = ["البريد الإلكتروني غير متوفر"];
    return;
  }

  state.isSendingEmailOtp = true;

  try {
    const payload = {
      request_type: OTP_TYPE.VERIFY_DONOR_EMAIL,
      mobile_number: state.donorPhone,
      email: "",
      model_id: '0',
    };

    const { data } = await OTPService.resendOTP(payload);
    if (data.status === 200) {
      state.verificationSent = true;
      state.emailOtpMode = true;
      state.emailOtpSent = true;
      state.donorOtp = "";
      startTimer();
    } 
  } catch (error) {
    console.error("Email OTP send error:", error);
    
    if (error.response?.data?.errors) {
      state.donorApiError = error.response.data.errors;
    } else {
      state.donorApiError = ["حدث خطأ أثناء إرسال رمز التحقق عبر البريد الإلكتروني. يرجى المحاولة مرة أخرى."];
    }
    
    state.emailOtpMode = false;
  } finally {
    state.isSendingEmailOtp = false;
  }
};

const handleDonorLogin = async () => {
  if (currentLoginRequest || state.isLoggingIn) {
    return;
  }

  state.donorPhoneError = "";
  state.donorApiError = [];
  state.otpError = "";

  if (!state.emailOtpMode && !saudiPhoneValidator(state.donorPhone)) {
    state.donorPhoneError = "الرجاء إدخال رقم جوال سعودي صحيح.";
    return;
  }

  if (!state.emailOtpMode && !isOtpValidForCurrentPhone.value) {
    state.otpError = "يرجى طلب رمز تحقق جديد لهذا الرقم";
    return;
  }

  if (state.donorOtp.length !== 6) {
    state.otpError = "يرجى إدخال رمز التحقق المكون من 6 أرقام";
    return;
  }

  if (!/^\d{6}$/.test(state.donorOtp)) {
    state.otpError = "رمز التحقق يجب أن يحتوي على أرقام فقط";
    return;
  }

  state.isLoggingIn = true;

  const payload = {
    mobile_number: state.donorPhone,
    otp: state.donorOtp,
  };

  if (state.emailOtpMode && state.donorEmail) {
    payload.email = state.donorEmail;
    payload.type = 'email';
  }

  if (state.isNewUser && state.termsAccepted) {
    payload.user_agreed = true;
  }

  try {
    currentLoginRequest = AuthService.verifyOtp(payload, true);
    const { data } = await currentLoginRequest;
    
    const { user } = data.result;
    const clientId = user.user_type === "donor" ? "shefa-doner-client" : "shefa-charity-client";
    
    JwtUtilService.setClientID(clientId);
    store.commit(STORE_ENUM.CUSTOM_AUTHENTICATE, data.result);

    if (state.newDonor) {
      setLocalValue("new_donor", true);
    }

    const redirectParam = route.query.redirect;
    const redirectURL = redirectParam ? `/${redirectParam}` : "/home";

    setLocalValue("username", user.first_name || user.mobile_number);
    setLocalValue("donor_mobile_number", user.mobile_number);
    setLocalValue("currentUser", user.realmName || user.user_type);
    setLocalValue("useremail", user.email);

    resetDonorState();
    
    router.push(redirectURL);
    
  } catch (error) {
    console.error("Donor login error:", error);
    
    if (error.response?.data?.errors) {
      state.donorApiError = error.response.data.errors;
    } else {
      state.donorApiError = ["حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى."];
    }
  } finally {
    state.isLoggingIn = false;
    currentLoginRequest = null;
  }
};

const handleEndowmentDonorLogin = async () => {
  if (currentLoginRequest || state.isLoggingIn) {
    return;
  }

  state.donorPhoneError = "";
  state.donorApiError = [];
  state.otpError = "";

  if (!state.emailOtpMode && !saudiPhoneValidator(state.donorPhone)) {
    state.donorPhoneError = "الرجاء إدخال رقم جوال سعودي صحيح.";
    return;
  }

  if (!state.emailOtpMode && !isOtpValidForCurrentPhone.value) {
    state.otpError = "يرجى طلب رمز تحقق جديد لهذا الرقم";
    return;
  }

  if (state.donorOtp.length !== 6) {
    state.otpError = "يرجى إدخال رمز التحقق المكون من 6 أرقام";
    return;
  }

  if (!/^\d{6}$/.test(state.donorOtp)) {
    state.otpError = "رمز التحقق يجب أن يحتوي على أرقام فقط";
    return;
  }

  state.isLoggingIn = true;

  const payload = {
    mobile_number: state.donorPhone,
    otp: state.donorOtp,
  };

  if (state.emailOtpMode && state.donorEmail) {
    payload.email = state.donorEmail;
    payload.type = 'email';
  }

  if (state.isNewUser && state.termsAccepted) {
    payload.user_agreed = true;
  }

  try {
    currentLoginRequest = AuthService.verifyOtp(payload, true);
    const { data } = await currentLoginRequest;
    
    const { user } = data.result;
    const clientId = user.user_type === "donor" ? "shefa-doner-client" : "shefa-charity-client";
    
    JwtUtilService.setClientID(clientId);
    store.commit(STORE_ENUM.CUSTOM_AUTHENTICATE, data.result);

    if (state.newDonor) {
      setLocalValue("new_donor", true);
    }

    const redirectParam = route.query.redirect;
    const redirectURL = redirectParam ? `/${redirectParam}` : "/home?mode=endowments";

    setLocalValue("username", user.first_name || user.mobile_number);
    setLocalValue("donor_mobile_number", user.mobile_number);
    setLocalValue("currentUser", user.realmName || user.user_type);
    setLocalValue("useremail", user.email);

    resetDonorState();
    
    router.push(redirectURL);
    
  } catch (error) {
    console.error("Endowment donor login error:", error);
    
    if (error.response?.data?.errors) {
      state.donorApiError = error.response.data.errors;
    } else {
      state.donorApiError = ["حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى."];
    }
  } finally {
    state.isLoggingIn = false;
    currentLoginRequest = null;
  }
};

const handleCharityLogin = async () => {
  if (state.isCharityLoggingIn) {
    return;
  }

  state.charityPhoneError = "";
  state.charityApiError = [];

  if (!saudiPhoneValidator(state.charityPhone)) {
    state.charityPhoneError = "الرجاء إدخال رقم جوال سعودي صحيح.";
    return;
  }

  if (!state.charityPassword) {
    state.charityApiError = ["يرجى إدخال كلمة المرور"];
    return;
  }

  state.isCharityLoggingIn = true;

  const payload = {
    mobile_number: state.charityPhone,
    password: state.charityPassword,
    user_type: "charity",
  };

  try {
    const { data } = await AuthService.customUserLogin(payload, true);
    const { user } = data.result;

    JwtUtilService.setClientID("shefa-charity-client");
    store.commit(STORE_ENUM.CUSTOM_AUTHENTICATE, data.result);

    const redirectParam = route.query.redirect;
    let redirectURL = "/home";

    if (user.is_password_set === false) {
      redirectURL = `/reset-password?type=${user.realmName}`;
    } else if (
      user.is_signed_agreement_uploaded === false &&
      user.realmName === "charity"
    ) {
      redirectURL = "/upload-signed-agreement";
    } else if (
      user.is_agreement_approved === false &&
      user.realmName === "charity"
    ) {
      redirectURL = "/agreement-approval";
    } else if (redirectParam) {
      redirectURL = `/${redirectParam}`;
    }

    const charity_approval_info = {
      is_password_set: user.is_password_set,
      is_signed_agreement_uploaded: user.is_signed_agreement_uploaded,
      is_agreement_approved: user.is_agreement_approved,
    };

    setLocalValue("charity_approval_info", charity_approval_info);
    setLocalValue("username", user.first_name);

    if (user.email) {
      setLocalValue("useremail", user.email);
    }
    
    setLocalValue("mobile_number", user.mobile_number);
    setLocalValue("currentUser", user.realmName || user.user_type);

    if (user.related_charity) {
      const accStatus = (user.status === 'deactivated' || user.status === 'expired_license') ? user.status : 'active';
      const suspendedAccDialogShow = (user.status === 'deactivated' || user.status === 'expired_license');

      setLocalValue("user_charity_id", user.related_charity);
      setLocalValue("charity_name", user.charity_name || "");
      setLocalValue("charity_account_state", { accStatus, suspendedAccDialogShow });
    }

    resetCharityState();
    
    router.push(redirectURL);
    
  } catch (error) {
    console.error("Charity login error:", error);
    
    if (error.response?.data?.errors) {
      state.charityApiError = error.response.data.errors;
    } else {
      state.charityApiError = ["حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى."];
    }
  } finally {
    state.isCharityLoggingIn = false;
  }
};

const backToSmsMode = () => {
  clearTimer();
  state.emailOtpMode = false;
  state.emailOtpSent = false;
  state.donorOtp = "";
  state.otpError = "";
  state.donorApiError = [];
  state.timerCount = 0;
};

const openAlert = () => {
  state.addCharityDisabledPopup = true;
}

onMounted(() => {
  state.webOtpSupported = "OTPCredential" in window && "navigator" in window && "credentials" in navigator;
  
  if (state.verificationSent && state.webOtpSupported) {
    startOtpDetection();
  }
});

onUnmounted(() => {
  stopOtpDetection();
  clearTimer();
  
  if (currentOtpRequest) {
    currentOtpRequest = null;
  }
  
  if (currentLoginRequest) {
    currentLoginRequest = null;
  }
});
</script>

<style lang="scss" scoped>
.container {
  margin: 0;
  max-width: unset;
  background-color: white;
}
.loginform {
  display: block;
  max-width: 790px;
  margin: 5px auto;
  padding: 0.5rem;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  font-weight: lighter;
  background-image: linear-gradient(rgba(255, 255, 255, 0), #f7f7f7);

  @media screen and (min-width:575px) {
    padding: 5rem;
  }

  :deep(.p-tabview-nav li) {
    flex-grow: 1;
  }
  :deep(.p-tabview-nav li .p-tabview-nav-link) {
    justify-content: center;
    font-size: 1.3rem;
  }
  :deep(.p-tabview-nav .p-tabview-nav-link:focus) {
    box-shadow: none !important;
  }
  .login-header {
    text-align: center;
    margin-bottom: 2rem;

    h3 {
      font-weight: 700;
      margin-bottom: 0.5rem;
    }

    p {
      color: #6c757d;
      font-size: 1.2rem;
    }
  }
  .forget-password {
    a {
      text-decoration: none;
    }
    .forget-password-text {
      color: #5581c4;
      cursor: pointer;
      &:hover {
        color: #345994;
      }
    }
  }
  :deep(.p-button) {
    font-size: 1.2rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  :deep(.p-3) {
    padding: 0.5rem !important;
  }
  .extra-links {
    a,
    .link-btn {
      color: #5581c4;
      text-decoration: none;
      &:hover {
        color: #345994;
      }
    }
    .link-btn {
      background: none;
      border: none;
      padding: 0;
    }
    span {
      color: #5581c4;
    }
  }
  .p-input-icon-left {
    .btn-verify {
      font-weight: 500;
      position: absolute;
      top: 50%;
      left: 0.9rem;
      transform: translateY(-50%);
      z-index: 2;
      color: white;
      background-color: #5fc7c2;
      padding: 0.1rem 0.8rem;
      border-radius: 1rem;
      font-size: 0.8rem;

      &:hover,
      &:focus {
        background-color: #3ca5a0;
        color: white;
        box-shadow: none;
      }
      
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
    :deep(.p-inputtext) {
      padding-left: 5rem;
    }
  }
}
.btn-toggle-mask {
  cursor: pointer;
  padding-left: 0.4rem;
}
.api-error-container {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
}

// Loading states
:deep(.p-button-loading) {
  opacity: 0.8;
  pointer-events: none;
}

:deep(.p-button-loading .p-button-icon) {
  animation: p-button-spin 1s linear infinite;
}

@keyframes p-button-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

// endowment mode login css
.endowment-login-section {
  min-height: auto;
  background-color: #F5FCFC;
  padding: 2rem 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.endowment-login-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 5rem 0;
}

.endowment-login-card {
  background: white;
  border-radius: 8px !important;
  box-shadow: 0px 3px 6px #0000003E !important;
  overflow: hidden;
  
  .card-content {
    padding: 2.5rem 2rem;
    
    @media screen and (min-width: 576px) {
      padding: 3rem 3.5rem;
    }
  }
  
  .login-header {
    text-align: center;
    margin-bottom: 2rem;
    
    h3 {
      font-weight: 700;
      font-size: 1.75rem;
      color: #333;
      margin-bottom: 0.75rem;
    }
    
    p {
      color: #6c757d;
      font-size: 1rem;
      line-height: 1.6;
      margin: 0;
    }
  }
  
  .endowment-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .error-messages {
    margin-bottom: 0.5rem;
  }
  
  .input-row {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    overflow: hidden;
    transition: border-color 0.2s ease;
    
    &:focus-within {
      border-color: #007F5C;
    }
    
    .phone-input,
    .otp-input {
      flex: 1;
      border: none;
      background: transparent;
      padding: 1rem 1rem 1rem 6rem;
      font-size: 1rem;
      direction: rtl;
      text-align: right;
      
      &:focus {
        box-shadow: none;
        outline: none;
      }
      
      &.p-invalid {
        border: none;
      }
    }
    
    .input-label {
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
      font-size: 1rem;
      pointer-events: none;
      transition: all 0.2s ease;
    }
    
    .phone-input:focus + .input-label,
    .phone-input:not(:placeholder-shown) + .input-label,
    .otp-input:focus + .input-label,
    .otp-input:not(:placeholder-shown) + .input-label {
      display: none;
    }
    
    .verify-btn {
      position: absolute;
      left: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
      background-color: #007F5C !important;
      border-color: #007F5C !important;
      color: #A3E3DA !important;
      padding: 0.5rem 1.25rem;
      border-radius: 0.375rem;
      font-size: 0.9rem;
      font-weight: 500;
      min-width: 80px;
      
      &:hover {
        background-color: darken(#007F5C, 5%) !important;
        border-color: darken(#007F5C, 5%) !important;
      }
      
      &:focus,
      &:active {
        background-color: darken(#007F5C, 5%) !important;
        border-color: darken(#007F5C, 5%) !important;
        box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #007F5C !important;
      }
      
      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
  }
  
  .p-error {
    color: #dc3545;
    font-size: 0.85rem;
    padding-right: 0.5rem;
  }
  
  .email-otp-heading {
    h5 {
      color: #333;
      font-weight: 600;
      font-size: 1rem;
      margin: 0;
    }
  }
  
  .email-otp-link {
    color: #5581c4;
    text-decoration: none;
    font-size: 0.95rem;
    
    &:hover {
      color: #345994;
      text-decoration: underline;
    }
  }
  
  .terms-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    
    .terms-label {
      display: flex;
      gap: 0.25rem;
      font-size: 0.95rem;
      
      a {
        color: #5581c4;
        text-decoration: underline;
        
        &:hover {
          color: #345994;
        }
      }
    }
  }
  
  .login-btn {
    width: 100%;
    background-color: #007F5C !important;
    border-color: #007F5C !important;
    color: #A3E3DA !important;
    padding: 0.875rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    border-radius: 0.5rem;
    margin-top: 1rem;
    
    &:hover {
      background-color: darken(#007F5C, 5%) !important;
      border-color: darken(#007F5C, 5%) !important;
    }
    
    &:focus,
    &:active {
      background-color: darken(#007F5C, 5%) !important;
      border-color: darken(#007F5C, 5%) !important;
      box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #007F5C !important;
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
  
  .back-btn {
    width: 100%;
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: white !important;
    padding: 0.875rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    border-radius: 0.5rem;
    margin-top: 0.5rem;
    
    &:hover {
      background-color: #5a6268 !important;
      border-color: #5a6268 !important;
    }
  }
}
</style>